// ABOUTME: Blue arrow pointing right icon component
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const ArrowBlueIcon = ({ className = "", size = 10, color = "#004FE0" }: IconProps) => (
  <svg
    width={size}
    height={size * 0.8}
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0 4C0 4.10608 0.0438967 4.20782 0.122034 4.28283C0.200171 4.35784 0.306149 4.39998 0.416653 4.39998H8.57732L5.53836 7.31681C5.49965 7.35398 5.46894 7.39809 5.44799 7.44665C5.42704 7.4952 5.41626 7.54724 5.41626 7.5998C5.41626 7.65235 5.42704 7.70439 5.44799 7.75295C5.46894 7.8015 5.49965 7.84562 5.53836 7.88278C5.57707 7.91995 5.62303 7.94942 5.67361 7.96954C5.72419 7.98965 5.7784 8 5.83314 8C5.88789 8 5.9421 7.98965 5.99268 7.96954C6.04326 7.94942 6.08921 7.91995 6.12792 7.88278L9.8778 4.28298C9.91654 4.24584 9.94727 4.20172 9.96824 4.15317C9.98921 4.10461 10 4.05256 10 4C10 3.94744 9.98921 3.89539 9.96824 3.84683C9.94727 3.79828 9.91654 3.75416 9.8778 3.71702L6.12792 0.117216C6.04974 0.0421638 5.94371 -7.90802e-10 5.83314 0C5.72258 7.90802e-10 5.61654 0.0421638 5.53836 0.117216C5.46018 0.192268 5.41626 0.29406 5.41626 0.4002C5.41626 0.50634 5.46018 0.608132 5.53836 0.683184L8.57732 3.60002H0.416653C0.306149 3.60002 0.200171 3.64216 0.122034 3.71717C0.0438967 3.79218 0 3.89392 0 4Z"
      fill={color}
    />
  </svg>
)
